import type { ProjectStatus, SystemStatus, EquipmentStatus, ChecklistStatus, PunchItemStatus, SubmittalStatus, IssueStatus } from '../../types'

type AnyStatus = ProjectStatus | SystemStatus | EquipmentStatus | ChecklistStatus | PunchItemStatus | SubmittalStatus | IssueStatus

const statusMap: Record<string, { className: string; label: string }> = {
  Draft: { className: 'badge badge-info-light', label: 'Draft' },
  Active: { className: 'status-badge active', label: 'Active' },
  OnHold: { className: 'badge badge-warning-light', label: 'On Hold' },
  Completed: { className: 'badge badge-success-light', label: 'Completed' },
  Cancelled: { className: 'badge badge-gray-light', label: 'Cancelled' },
  NotStarted: { className: 'badge badge-gray-light', label: 'Not Started' },
  InProgress: { className: 'status-badge in-progress', label: 'In Progress' },
  Deferred: { className: 'badge badge-warning-light', label: 'Deferred' },
  Pending: { className: 'status-badge pending', label: 'Pending' },
  Installed: { className: 'badge badge-info-light', label: 'Installed' },
  Tested: { className: 'badge badge-primary-light', label: 'Tested' },
  Commissioned: { className: 'badge badge-success-light', label: 'Commissioned' },
  Deficient: { className: 'badge badge-danger-light', label: 'Deficient' },
  Open: { className: 'badge badge-danger-light', label: 'Open' },
  Resolved: { className: 'badge badge-success-light', label: 'Resolved' },
  Closed: { className: 'badge badge-gray-light', label: 'Closed' },
  Under_Review: { className: 'badge badge-info-light', label: 'Under Review' },
  Approved: { className: 'badge badge-success-light', label: 'Approved' },
  Approved_As_Noted: { className: 'badge badge-warning-light', label: 'Approved as Noted' },
  Rejected: { className: 'badge badge-danger-light', label: 'Rejected' },
  Resubmit: { className: 'badge badge-warning-light', label: 'Resubmit' },
  PendingResponse: { className: 'badge badge-warning-light', label: 'Pending Response' },
  Verified: { className: 'badge badge-success-light', label: 'Verified' },
}

interface StatusBadgeProps {
  status: AnyStatus
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const config = statusMap[status] || { className: 'badge badge-gray', label: status }
  return <span className={config.className}>{config.label}</span>
}
